import { createAction } from '@/utility/actions';

import { WP_BLOG_GET_PAGE } from './_types.ts';

/**
 * getWPPage - params: params(slug)
 */
export const getWPPage = createAction(WP_BLOG_GET_PAGE);

export default {
  getWPPage,
};
